import { createApp } from 'vue'
import App from './App.vue'
import KnotTimer from "./components/KnotTimer.vue";
import KnotBoard from "./components/KnotBoard.vue";
import KnotKeyboard from "./components/KnotKeyboard.vue";
import PrivacyModal from "./components/PrivacyModal.vue";
import HelpModal from "./components/HelpModal.vue";
import StatisticsModal from "./components/StatisticsModal.vue";
import SettingsModal from "./components/SettingsModal.vue";
import KnotCarousel from "./components/KnotCarousel.vue";
import KnotSelect from "./components/KnotSelect.vue";
import BenchmarksModal from "./components/BenchmarksModal.vue";
import AnnouncementModal from "./components/AnnouncementModal.vue";
import PartnerGamesModal from "./components/PartnerGamesModal.vue";
import HubModal from "./components/HubModal.vue";
import LeaderboardModal from "./components/LeaderboardModal.vue";
import MultiActionButton from "./components/MultiActionButton.vue";
import KnotBoardDemo from "./components/KnotBoardDemo.vue";
import SequenceHelp from "./components/SequenceHelp.vue";

const app = createApp(App);
app.component('KnotTimer', KnotTimer);
app.component('KnotBoard', KnotBoard);
app.component('KnotKeyboard', KnotKeyboard);
app.component('PrivacyModal', PrivacyModal);
app.component('HelpModal', HelpModal);
app.component('StatisticsModal', StatisticsModal);
app.component('SettingsModal', SettingsModal);
app.component('KnotCarousel', KnotCarousel);
app.component('KnotSelect', KnotSelect);
app.component('BenchmarksModal', BenchmarksModal);
app.component('AnnouncementModal', AnnouncementModal);
app.component('PartnerGamesModal', PartnerGamesModal);
app.component('LeaderboardModal', LeaderboardModal);
app.component('MultiActionButton', MultiActionButton);
app.component('HubModal', HubModal);
app.component('KnotBoardDemo', KnotBoardDemo);
app.component('SequenceHelp', SequenceHelp);

app.mount('#app');
